import { Card, CardBody, Table } from '@statsbomb/kitbag-components';
import moment from 'moment';
import { PropTypes } from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useTheme } from 'styled-components';
import useApi, { API_ENDPOINTS } from '../../hooks/api';
import usePoll from '../../hooks/poll';
import { POLL_FREQUENCIES } from '../../utils/polling';
import CardHeader from '../CardHeader';
import CellHeadings from '../CellHeadings';

export function EditsDisplay({ displayCount, isHideComplete, title }) {
  const api = useApi();
  const intl = useIntl();

  const theme = useTheme();
  const isSmallScreen = !theme.mqMatch(theme.mqFrom('md'));

  const getAllData = async () => {
    await api.get(
      `${API_ENDPOINTS.videoService}/edits?private=${isHideComplete}`,
    );
  };

  usePoll(getAllData, POLL_FREQUENCIES.EDITS);

  const byId = (a, b) => {
    if (a.Id > b.Id) {
      return -1;
    }
    if (a.Id < b.Id) {
      return 1;
    }
    return 0;
  };

  const jobs = api.response?.data?.Jobs.sort(byId).slice(0, displayCount);

  return (
    <Card>
      <CardHeader>
        {title || (
          <FormattedMessage defaultMessage="Re-encoding Processes" id="a38f9" />
        )}
      </CardHeader>
      <CardBody>
        {isSmallScreen ? (
          <Table size="small" aria-label="edits">
            <CellHeadings
              cells={[
                {
                  children: intl.formatMessage({
                    defaultMessage: 'Destination (Status)',
                    id: '2719d',
                  }),
                  id: 'Destination',
                },
              ]}
              textAlign="left"
            />
            <Table.Body>
              {jobs?.length > 0 ? (
                jobs?.map((job) => (
                  <Table.Row key={`table-row-${job.Id}`}>
                    <Table.DataCell $textAlign="left">
                      {intl.formatMessage(
                        {
                          defaultMessage: '{destination} {status}',
                          id: '81218',
                        },
                        {
                          destination: job.Destination,
                          status:
                            job.PercentageComplete && job.PercentageComplete
                              ? `(${job.Status} ${job.PercentageComplete})`
                              : `(${job.Status})`,
                        },
                      )}
                    </Table.DataCell>
                  </Table.Row>
                ))
              ) : (
                <Table.Row key="table-row-empty-edits">
                  <Table.DataCell $textAlign="left">
                    <FormattedMessage
                      defaultMessage="Jobs will appear here"
                      id="fa1da"
                    />
                  </Table.DataCell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        ) : (
          <Table size="small" aria-label="edits">
            <CellHeadings
              cells={[
                {
                  children: intl.formatMessage({
                    defaultMessage: 'Destination',
                    description: 'Destination',
                    id: 'ef9ff',
                  }),
                  id: 'Destination',
                },
                {
                  children: intl.formatMessage({
                    defaultMessage: 'Status',
                    description: 'Status',
                    id: 'dc56e',
                  }),
                  id: 'Status',
                },
                {
                  children: intl.formatMessage({
                    defaultMessage: 'Created At',
                    description: 'Created At',
                    id: 'f9233',
                  }),
                  id: 'CreatedAt',
                },
              ]}
              textAlign="left"
            />
            <Table.Body>
              {jobs && jobs.length ? (
                jobs?.map((job) => (
                  <Table.Row key={`table-row-${job.Id}`}>
                    <Table.DataCell $textAlign="left">
                      {job.Destination}
                    </Table.DataCell>
                    <Table.DataCell $textAlign="left">
                      {job.Status}
                      {job.PercentageComplete &&
                        ` (${job.PercentageComplete}%)`}
                    </Table.DataCell>
                    <Table.DataCell $textAlign="left">
                      {moment(job.CreatedAt).fromNow()}
                    </Table.DataCell>
                  </Table.Row>
                ))
              ) : (
                <Table.Row key="table-row-empty-edits">
                  <Table.DataCell $textAlign="left" colSpan={3}>
                    <FormattedMessage
                      defaultMessage="Jobs will appear here"
                      id="fa1da"
                    />
                  </Table.DataCell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        )}
      </CardBody>
    </Card>
  );
}
EditsDisplay.propTypes = {
  displayCount: PropTypes.number,
  isHideComplete: PropTypes.bool,
  title: PropTypes.string,
};
EditsDisplay.defaultProps = {
  displayCount: 5,
  isHideComplete: false,
  title: undefined,
};

export default { EditsDisplay };
